import { z } from 'zod';

export const seasonValues = ['spring', 'summer', 'fall', 'winter', 'any'] as const;
export const seasonEnum = z.enum(seasonValues);
export type Season = z.infer<typeof seasonEnum>;

export const guideStatusValues = ['draft', 'active', 'deprecated', 'archived'] as const;
export const guideStatusEnum = z.enum(guideStatusValues);
export type GuideStatus = z.infer<typeof guideStatusEnum>;

export const checklistRunStatusValues = [
  'not_started',
  'in_progress',
  'completed',
  'skipped',
  'archived',
] as const;
export const checklistRunStatusEnum = z.enum(checklistRunStatusValues);
export type ChecklistRunStatus = z.infer<typeof checklistRunStatusEnum>;

export const checklistRunItemStatusValues = ['open', 'done', 'skipped', 'blocked'] as const;
export const checklistRunItemStatusEnum = z.enum(checklistRunItemStatusValues);
export type ChecklistRunItemStatus = z.infer<typeof checklistRunItemStatusEnum>;

export const equipmentStatusValues = ['active', 'inactive', 'broken', 'archived'] as const;
export const equipmentStatusEnum = z.enum(equipmentStatusValues);
export type EquipmentStatus = z.infer<typeof equipmentStatusEnum>;

export const toolStatusValues = [
  'active',
  'missing',
  'broken',
  'loaned_out',
  'replace',
  'archived',
] as const;
export const toolStatusEnum = z.enum(toolStatusValues);
export type ToolStatus = z.infer<typeof toolStatusEnum>;

export const projectStatusValues = [
  'planned',
  'active',
  'blocked',
  'completed',
  'abandoned',
  'archived',
] as const;
export const projectStatusEnum = z.enum(projectStatusValues);
export type ProjectStatus = z.infer<typeof projectStatusEnum>;

export const projectPriorityValues = ['low', 'medium', 'high', 'urgent'] as const;
export const projectPriorityEnum = z.enum(projectPriorityValues);
export type ProjectPriority = z.infer<typeof projectPriorityValues[number] extends string ? typeof projectPriorityEnum : never>;

export const allowedMimeValues = [
  'image/jpeg',
  'image/png',
  'image/webp',
  'application/pdf',
] as const;
export const allowedMimeEnum = z.enum(allowedMimeValues);
export type AllowedMime = z.infer<typeof allowedMimeEnum>;

export const kitItemTypeValues = ['tool', 'consumable', 'equipment_part'] as const;
export const kitItemTypeEnum = z.enum(kitItemTypeValues);
export type KitItemType = z.infer<typeof kitItemTypeEnum>;

export const logEntityTypeValues = [
  'equipment',
  'tool',
  'project',
  'checklist_run',
  'property_zone',
] as const;
export const logEntityTypeEnum = z.enum(logEntityTypeValues);
export type LogEntityType = z.infer<typeof logEntityTypeEnum>;

export const assetEntityTypeValues = [
  'equipment',
  'tool',
  'project',
  'checklist_run',
  'property_zone',
  'maintenance_log',
] as const;
export const assetEntityTypeEnum = z.enum(assetEntityTypeValues);
export type AssetEntityType = z.infer<typeof assetEntityTypeEnum>;
